module.exports = __webpack_public_path__ + "img/logo.f86804b5.png";